<div class="d-flex flex-column p-medium gap-medium">
  <!-- Message -->
  <div class="d-flex flex-row justify-content-center align-items-center py-large">
    {{ messageData().message }}
  </div>
  <!-- End Message -->
  <!-- Buttons -->
  <div class="buttons d-flex flex-row gap-pony">
    <common-ui-components-temp-ngx-button (click)="handleAcceptClick()">
      {{ acceptButtonLabel() }}
    </common-ui-components-temp-ngx-button>

    <common-ui-components-temp-ngx-button
      [style]="'tinted-on-elevated'"
      (click)="handleDeclineClick()"
    >
      {{ declineButtonLabel() }}
    </common-ui-components-temp-ngx-button>
  </div>
  <!-- End Buttons -->
</div>
